import request from '../request'

export default {
  login: (credentials) => {
    return request.post('auth/login', credentials)
  }
}
